import { render, staticRenderFns } from "./AdminErrors.vue?vue&type=template&id=12c42b8a&"
import script from "./AdminErrors.vue?vue&type=script&lang=js&"
export * from "./AdminErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports